import React from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import EventsOverview from './components/EventsOverview'
import EventHub from './components/EventHub'
import EventSectionView from './components/EventSectionView'

// Routen der Event-App. createBrowserRouter statt Hash-Router: die heutigen
// URLs müssen erhalten bleiben, und jede Event-Unterseite ist eine eigene,
// direkt aufrufbare Route (Spec Abschnitt 9). Eigenes Modul, damit Tests
// denselben Baum mit createMemoryRouter fahren.
// Ein Wechsel innerhalb der App laedt keine neue Seite. ScrollRestoration
// setzt darum wie ein aufgerufener Link nach oben zurueck (#82) und stellt
// bei Zurueck/Vor die alte Position wieder her. Anker (#aussteller-<id>)
// greifen erst, wenn die Listen stehen — das macht useHashScroll (#53).
const Rahmen = () => (
    <>
        <ScrollRestoration />
        <Outlet />
    </>
)

const eventsRoutes = [{
    element: <Rahmen />,
    children: [
        { path: '/events/', element: <EventsOverview /> },
        { path: '/events/:eventSlug/', element: <EventHub /> },
        // Der Abschnitt hat seine eigene View ohne Kachelraster (#82), seit
        // 2026-09-30 mit gekuerzter Sidebar.
        { path: '/events/:eventSlug/:sectionSlug/', element: <EventSectionView /> }
    ]
}]

export default eventsRoutes
